import { c as _c } from "react/compiler-runtime";
import { AgencyBanner } from '@/app/donation/_components/AgencyBanner';
import { HeroImage } from '../../GiftDetailHeader/_components/HeroImage';
interface MobileHeroProps {
  heroImageUrlList: string[];
  adultYN: boolean;
}
export const MobileHero = t0 => {
  const $ = _c(6);
  const {
    heroImageUrlList,
    adultYN
  } = t0;
  let t1;
  if ($[0] !== adultYN || $[1] !== heroImageUrlList) {
    t1 = <HeroImage heroImageUrlList={heroImageUrlList} adultYN={adultYN} />;
    $[0] = adultYN;
    $[1] = heroImageUrlList;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AgencyBanner />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="hidden mobile:block tablet:block">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};